import { type RegionalOverviewLevel } from '../regional-overview.models';

export enum VariableTypes {
  AGRONOMIC_CLASS = 'agronomic_class',
  BLOOMING_DATE = 'blooming_date',
  FIELD_SIZE = 'field_size',
  PLANTING_DATE = 'planting_date',
  RISK = 'risk',
  RISK_VALUE = 'risk_value',
  PREVIOUSLY_CROP = 'previously_crop',
  TILLAGE = 'tillage',
  VARIETY = 'variety',
  PROPERTY_NAME = 'property_name'
}

export enum RegionalRiskMycotoxinRiskLevelColors {
  NO_RISK = '#C2C7D0',
  LOW_RISK = '#19A04B',
  MEDIUM_RISK = '#FFA858',
  HIGH_RISK = '#FF785A',
  VERY_HIGH_RISK = '#CF3537'
}

export const RegionalRiskMycotoxinHandlerStatistics = {
  '0': {
    riskColor: RegionalRiskMycotoxinRiskLevelColors.NO_RISK,
    riskName: 'pages.regional_overview.regional_mycotoxin.high_level_statistics.level_risk.no_risk'
  },
  '1': {
    riskColor: RegionalRiskMycotoxinRiskLevelColors.LOW_RISK,
    riskName: 'pages.regional_overview.regional_mycotoxin.high_level_statistics.level_risk.low_risk'
  },
  '2': {
    riskColor: RegionalRiskMycotoxinRiskLevelColors.MEDIUM_RISK,
    riskName: 'pages.regional_overview.regional_mycotoxin.high_level_statistics.level_risk.medium_risk'
  },
  '3': {
    riskColor: RegionalRiskMycotoxinRiskLevelColors.HIGH_RISK,
    riskName: 'pages.regional_overview.regional_mycotoxin.high_level_statistics.level_risk.high_risk'
  },
  '4': {
    riskColor: RegionalRiskMycotoxinRiskLevelColors.VERY_HIGH_RISK,
    riskName: 'pages.regional_overview.regional_mycotoxin.high_level_statistics.level_risk.very_high_risk'
  }
};
export interface IHighLevelStatistics {
  name: string;
  z: number;
  y: number;
  areaSize: string;
  totalFields: number;
  color: string;
}

export const regionalMycotoxinLevels: RegionalOverviewLevel[] = [
  {
    type: 'no_risk',
    level: 10,
    value: '0',
    legend_color: RegionalRiskMycotoxinRiskLevelColors.NO_RISK,
    text_color: '#363948'
  },
  {
    type: 'low_risk',
    level: 22,
    value: '1',
    legend_color: RegionalRiskMycotoxinRiskLevelColors.LOW_RISK,
    text_color: '#363948'
  },
  {
    type: 'medium_risk',
    level: 22,
    value: '2',
    legend_color: RegionalRiskMycotoxinRiskLevelColors.MEDIUM_RISK,
    text_color: '#363948'
  },
  {
    type: 'high_risk',
    level: 22,
    value: '3',
    legend_color: RegionalRiskMycotoxinRiskLevelColors.HIGH_RISK,
    text_color: '#363948'
  },
  {
    type: 'very_risk',
    level: 22,
    value: '4',
    legend_color: RegionalRiskMycotoxinRiskLevelColors.VERY_HIGH_RISK,
    text_color: '#363948'
  }
];
